import React from 'react'

const FlashIcon = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
  xmlns="http://www.w3.org/2000/svg"
  width={37}
  height={56}
  viewBox="0 0 37 56"
  fill="none"
  {...props}
>
  <g filter="url(#filter0_d_505_1263)">
    <path
      d="M33 0H15.0476L4 23.3077L15.0476 21.9231L10.4444 30H5.38095V48L23.7937 30H18.0397L31.619 15L21.4921 16.1538L33 0Z"
      fill="url(#paint0_linear_505_1263)"
    />
  </g>
  <defs>
    <filter
      id="filter0_d_505_1263"
      x={0}
      y={0}
      width={37}
      height={56}
      filterUnits="userSpaceOnUse"
      colorInterpolationFilters="sRGB"
    >
      <feFlood floodOpacity={0} result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy={4} />
      <feGaussianBlur stdDeviation={2} />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_505_1263"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_505_1263"
        result="shape"
      />
    </filter>
    <linearGradient
      id="paint0_linear_505_1263"
      x1="18.5"
      y1={0}
      x2="18.5"
      y2={48}
      gradientUnits="userSpaceOnUse"
    >
      <stop stopColor="#FF5612" />
      <stop offset={1} stopColor="#F03906" />
    </linearGradient>
  </defs>
</svg>

  )
}

export default FlashIcon